import { moduleProviderFactory } from 'core/providers';
import { ClinicalStatusEdit, ClinicalStatusList } from 'application/clinical-status/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.clinical-status',
                pattern: '/clinical-status',
                children: [
                    {
                        name: 'master.app.main.clinical-status.list',
                        pattern: '',
                        tabTitle: 'CLINICAL_STATUS.LIST.TITLE_SECONDARY',
                        component: ClinicalStatusList,
                        data: {
                            title: 'CLINICAL_STATUS.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.clinical-status.create',
                        pattern: '/create',
                        tabTitle: 'Create Clinical Status',
                        component: ClinicalStatusEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'CLINICAL_STATUS.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.clinical-status.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Clinical Status',
                        component: ClinicalStatusEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'CLINICAL_STATUS.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.CLINICAL_STATUSS_SUB',
                        route: 'master.app.main.clinical-status.list',
                        order: 1,
                    }                    
                ]
            }
        ]
    });
})();
